import { Injectable } from '@angular/core';
import { filenameFromString } from '@epicuro-next/utilities';
import * as mime from 'mime-types';
import { from, Observable } from 'rxjs';

import { ZipFile } from './zip-file';

export interface BlobEntity {
  blob?: Blob;
  filename: string;
}

@Injectable()
export class ZipService {
  public fromBlobEntities(entities: Required<BlobEntity>[]): Observable<Blob> {
    const zip = new ZipFile();

    entities.forEach(({ blob, filename }) => {
      const extension = mime.extension(blob.type);
      zip.addFile(`${filenameFromString(filename)}.${extension}`, blob);
    });

    return from(zip.getBlob());
  }
}
